export const MAX_TOKENS_BEFORE_FETCH = 20;
export const MIN_SEARCH_LENGTH = 3;
